module.exports = __webpack_public_path__ + "static/media/happy_business.e981c4d4.png";